export { getUsernameValidationMessage } from "../../../helpers/usernameValidation";

export const PASSWORD_REQUIREMENTS_MESSAGE =
    "Password must be at least 8 characters and include uppercase, lowercase, and a special character.";

const passwordRequirementsRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/;
const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const getEmailValidationMessage = (email) => {
    if (!email || email.trim().length === 0) {
        return "Email is required.";
    }

    if (!emailRegex.test(email)) {
        return "Please enter a valid email address.";
    }

    return null;
};

export const getPasswordValidationMessage = (password) => {
    if (!password || password.length === 0) {
        return "Password is required.";
    }

    if (!passwordRequirementsRegex.test(password)) {
        return PASSWORD_REQUIREMENTS_MESSAGE;
    }

    return null;
};

export const getPasswordConfirmationValidationMessage = (password, pwdConfirm) => {
    if (!pwdConfirm || pwdConfirm.length === 0) {
        return "Password confirmation is required.";
    }

    if (password !== pwdConfirm) {
        return "Passwords do not match.";
    }

    return null;
};

export const getTermsValidationMessage = (termsAccepted) => {
    if (!termsAccepted) {
        return "You must accept the terms and conditions.";
    }

    return null;
};
